import { IApplicationState } from '../../types/redux';
import { selectCallbackPhone } from './selectCallbackPhone';
import { selectNewbuilding } from './selectNewbuilding';

export const selectIsCallbackAvailable = (state: IApplicationState) => {
  const { builderInfo, isDealRequestSubstitutionPhone } = selectNewbuilding(state);
  const callbackPhone = selectCallbackPhone(state);
  const realtyUserId = builderInfo?.realtyUserId;

  return Boolean(typeof realtyUserId === 'number' && callbackPhone && !isDealRequestSubstitutionPhone);
};
